import { cognitoApi } from '../cognitoApi';
import { CognitoAPIResponse } from '../types';
import { attachId, attachIds } from '../utils';

import {
  Course,
} from './types';

export const coursesApi = cognitoApi.injectEndpoints({
  endpoints: (build) => ({
    getCourses: build.query<CognitoAPIResponse<Course[]>, { subject?: string }>({
      query(arg) {
        const { subject } = arg;
        return {
          url: 'courses/query',
          method: 'GET',
          params: {
            subject,
          },
        };
      },
      providesTags: (result) => (result
        ? [...result.data.map(({ id }) =>
          ({ type: 'Courses' as const, id })), 'Courses']
        : ['Courses']),
      transformResponse(response: any) {
        return attachIds(response, (entry: any) => entry.courseId);
      },
    }),
    getCourse: build.query<CognitoAPIResponse<Course>, { courseId: string, }>({
      query(arg) {
        const { courseId } = arg;
        return {
          url: `courses/${courseId}`,
          method: 'GET',
        };
      },
      providesTags: (result) => [{
        type: 'Courses',
        id: result?.data.id,
      }],
      transformResponse(response: any) {
        return attachId(response, (entry: any) => entry.courseId);
      },
    }),
    updateCourse: build.mutation<any, {
      courseId: string,
      newAttributes: any,
    }>({
      query(arg) {
        const { courseId, newAttributes } = arg;

        return {
          url: `courses/${courseId}/update`,
          body: newAttributes,
          method: 'PUT',
        };
      },
      invalidatesTags: (result, error, arg) => [{ type: 'Courses', id: arg.courseId }],
    }),
    deleteCourse: build.mutation<any, {
      courseId: string,
    }>({
      query(arg) {
        const { courseId } = arg;

        return {
          url: `courses/${courseId}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: (result, error, arg) => [{ type: 'Courses', id: arg.courseId }],
    }),
    newCourse: build.mutation<any, {
      subject: string,
      attributes: any
    }>({
      query(arg) {
        const { subject, attributes } = arg;

        return {
          url: 'courses/new',
          body: {
            subject, ...attributes,
          },
          method: 'POST',
        };
      },
      invalidatesTags: ['Courses'],
    }),
  }),
});

export const {
  useGetCourseQuery,
  useGetCoursesQuery,
  useUpdateCourseMutation,
  useDeleteCourseMutation,
  useNewCourseMutation,
} = coursesApi;
